export const state = () => ({
  open: false,
  type: '', // 1: normal 2: dialog
  title: '',
  message: '',
  messageHTML: '',
  persistent: false,
  btnText: '確定',
  btnCancelText: '',
  btnDonFun: () => { },
  btn: [],
  leftBtn: [],
  clickOutside: null,
  isLoading: false,
  noBtn: false,
  showCloseIcon: false
})

export const getters = {
}

export const mutations = {
  toggle (state, status) {
    state.open = status
  },
  setAlert (state, dialog) {
    Object.entries(dialog).forEach(([key, value]) => {
      state[key] = value
    })
  },
  clear (state) {
    state.open = false
    state.type = 'normal'
    state.title = ''
    state.message = ''
    state.messageHTML = ''
    state.persistent = false
    state.btnText = '確定'
    state.btnCancelText = ''
    state.btn = []
    state.leftBtn = []
    state.isLoading = false
    state.noBtn = false
    state.btnDonFun = () => { }
    state.clickOutside = null
  },
  setDonFun (state, btnDonFun) {
    state.btnDonFun = btnDonFun
  },
  setBtnLoading (state, { index, status }) {
    if (state.btn[index]) {
      state.btn[index].btnIsLoading = status
    }
  },
  setBtnDisabled (state, { index, status }) {
    if (state.btn[index]) {
      state.btn[index].btnDisabled = status
    }
  }
}

export const actions = {
  open ({ commit }) {
    commit('toggle', true)
  },
  async close ({ commit }, delayTime = 400) {
    return new Promise((resolve, reject) => {
      commit('toggle', false)
      setTimeout(() => {
        commit('clear')
      }, delayTime > 300 ? 300 : delayTime)
      setTimeout(() => {
        resolve()
      }, delayTime)
    })
  }
}
